<template>
  <div class="info-modal">
    <!-- Header -->
    <div class="info-header">
      <div class="info-header__left">
        <div class="info-header__icon">
          <v-icon>{{ headerIcon }}</v-icon>
        </div>
        <div>
          <p class="info-header__eyebrow">Información</p>
          <h3 class="info-header__title">{{ headerTitle }}</h3>
        </div>
      </div>
      <v-btn icon class="info-close" @click="$emit('close-information')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <!-- Body -->
    <div class="info-body">
      <!-- Imagen -->
      <div v-if="isImagePath(item)" class="info-preview">
        <img :src="getPath(item)" alt="Adjunto" class="info-preview__img" />
        <a
          :href="getPath(item)"
          target="_blank"
          rel="noopener"
          class="info-link"
        >
          <v-icon small class="info-link__icon">open_in_new</v-icon>
          Ver en tamaño completo
        </a>
      </div>

      <!-- Archivo no imagen -->
      <div v-else-if="getPath(item)" class="info-file">
        <div class="info-file__icon">
          <v-icon>insert_drive_file</v-icon>
        </div>
        <div class="info-file__text">
          <p class="info-file__title">Documento adjunto</p>
          <p class="info-file__help">
            Haz clic para abrir o descargar el archivo.
          </p>
        </div>
        <a
          :href="getPath(item)"
          target="_blank"
          rel="noopener"
          class="info-btn info-btn--download"
        >
          <v-icon small class="info-btn__icon">cloud_download</v-icon>
          Abrir archivo
        </a>
      </div>

      <!-- Sin archivo -->
      <div v-else class="info-empty">
        <v-icon class="info-empty__icon">image_not_supported</v-icon>
        <p>No hay archivo adjunto.</p>
      </div>

      <!-- Observaciones -->
      <div v-if="item.observationsDenied" class="info-note">
        <span class="info-note__label">Observaciones</span>
        <p class="info-note__text">{{ item.observationsDenied }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getFullPath } from '@/helpers/TransitHelper'
import isImageUrl from 'is-image-url'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    headerTitle() {
      const titles = {
        rejected: 'Adjunto del rechazo',
        payment: 'Comprobante de pago',
        delivered: 'Comprobante de entrega',
      }
      return titles[this.item.type] || 'Detalle adjunto'
    },
    headerIcon() {
      const icons = {
        rejected: 'block',
        payment: 'receipt_long',
        delivered: 'local_shipping',
      }
      return icons[this.item.type] || 'info'
    },
  },
  methods: {
    getPath(item) {
      let path = ''
      if (item.type == 'rejected') {
        path = item.photoDenied
      } else if (item.type == 'payment') {
        path = item.photoPayed
      } else if (item.type == 'delivered') {
        path = item.photoDelivered
      }
      if (path) return getFullPath(path)
      else return null
    },
    isImagePath(item) {
      const path = this.getPath(item)
      return isImageUrl(path)
    },
  },
}
</script>

<style scoped>
.info-modal {
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
}

/* ===== Header ===== */
.info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 22px;
  background: linear-gradient(135deg, #254f87 0%, #1a3a63 100%);
  color: #ffffff;
}

.info-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.info-header__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
}

.info-header__icon .v-icon {
  color: #ffffff !important;
  font-size: 20px !important;
}

.info-header__eyebrow {
  margin: 0;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.75);
}

.info-header__title {
  margin: 2px 0 0;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
}

.info-close,
.info-close .v-icon {
  color: #ffffff !important;
}

/* ===== Body ===== */
.info-body {
  padding: 22px;
}

/* Imagen */
.info-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.info-preview__img {
  max-width: 100%;
  max-height: 360px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.info-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #254f87;
  text-decoration: none;
}

.info-link:hover {
  text-decoration: underline;
}

.info-link__icon {
  color: #254f87 !important;
}

/* Archivo */
.info-file {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fafbfd;
}

.info-file__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 10px;
  background: rgba(37, 79, 135, 0.1);
}

.info-file__icon .v-icon {
  color: #254f87 !important;
  font-size: 24px !important;
}

.info-file__text {
  flex: 1;
  min-width: 0;
}

.info-file__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #172133;
}

.info-file__help {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748b;
}

.info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.18s ease;
  white-space: nowrap;
}

.info-btn__icon {
  color: inherit !important;
  font-size: 17px !important;
}

.info-btn--download {
  background: #16a34a;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(22, 163, 74, 0.25);
}

.info-btn--download:hover {
  background: #15803d;
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.32);
  transform: translateY(-1px);
}

/* Sin archivo */
.info-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 30px 16px;
  color: #64748b;
}

.info-empty__icon {
  font-size: 42px !important;
  color: #94a3b8 !important;
}

/* Observaciones */
.info-note {
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
}

.info-note__label {
  display: block;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 6px;
}

.info-note__text {
  margin: 0;
  font-size: 14px;
  color: #172133;
  line-height: 1.55;
  white-space: pre-line;
}

@media (max-width: 600px) {
  .info-file {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }
  .info-btn--download {
    width: 100%;
  }
}
</style>
